import React from 'react';
import propTypes from 'prop-types';
import { DynamicIcon, dynamicIconImports } from 'lucide-react/dynamic';
import { isValidColor } from 'helpers/colors';

function CarrierLucideIcon({
  name,
  size = 18,
  className,
  color,
  whiteIcon = false
}) {
  const iconName = typeof name === 'string' ? name.trim() : '';

  if (!iconName || !(iconName in dynamicIconImports)) {
    return null;
  }

  let iconColor;
  if (whiteIcon) {
    iconColor = 'white';
  } else if (isValidColor(color)) {
    iconColor = color.trim();
  }

  return (
    <span
      style={{
        display: 'inline-flex',
        flexShrink: 0,
        lineHeight: 0
      }}
    >
      <DynamicIcon
        name={iconName}
        size={size}
        className={className}
        color={iconColor}
        aria-hidden
      />
    </span>
  );
}

CarrierLucideIcon.propTypes = {
  name: propTypes.string,
  size: propTypes.number,
  className: propTypes.string,
  color: propTypes.string,
  whiteIcon: propTypes.bool
};

export default CarrierLucideIcon;
